/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { MSTGQLRef, QueryBuilder, withTypedRefs } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { SolutionStatusOnlyDtoModel, SolutionStatusOnlyDtoModelType } from "./SolutionStatusOnlyDtoModel"
import { SolutionStatusOnlyDtoModelSelector } from "./SolutionStatusOnlyDtoModel.base"
import { RootStoreType } from "./index"


/* The TypeScript type that explicits the refs to other models in order to prevent a circular refs issue */
type Refs = {
  pendingSolution: SolutionStatusOnlyDtoModelType;
}

/**
 * ProjectRouteStopScheduledDtoBase
 * auto generated base class for the model ProjectRouteStopScheduledDtoModel.
 *
 * Route scheduled a stop
 */
export const ProjectRouteStopScheduledDtoModelBase = withTypedRefs<Refs>()(ModelBase
  .named('ProjectRouteStopScheduledDto')
  .props({
    __typename: types.optional(types.literal("ProjectRouteStopScheduledDto"), "ProjectRouteStopScheduledDto"),
    pendingSolution: types.union(types.undefined, MSTGQLRef(types.late((): any => SolutionStatusOnlyDtoModel))),
    status: types.union(types.undefined, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  })))

export class ProjectRouteStopScheduledDtoModelSelector extends QueryBuilder {
  get status() { return this.__attr(`status`) }
  pendingSolution(builder: string | SolutionStatusOnlyDtoModelSelector | ((selector: SolutionStatusOnlyDtoModelSelector) => SolutionStatusOnlyDtoModelSelector) | undefined) { return this.__child(`pendingSolution`, SolutionStatusOnlyDtoModelSelector, builder) }
}
export function selectFromProjectRouteStopScheduledDto() {
  return new ProjectRouteStopScheduledDtoModelSelector()
}

export const projectRouteStopScheduledDtoModelPrimitives = selectFromProjectRouteStopScheduledDto().status
